import * as React from "react";

import "react-international-phone/style.css";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { useState } from "react";

import { Chemical } from "../../../../models/chemical.interface";
import useApiService from "../../../../hooks/useApiService";
import { formDataType } from "../AddSite";
import { Checkbox } from "../../../../components/Shared/Forms";
import styles from "../add-site.module.css";

interface ChemicalsProps {
  handleChange: (name: string, value: string[]) => void;
  formData: formDataType;
}

export function Chemicals({ handleChange, formData }: ChemicalsProps) {
  const [chemicalData, setChemicalData] = useState<Chemical[]>([]);
  const [selectedChemicals, setSelectedChemicals] = useState<string[]>([]);

  const [allSelected, setAllSelected] = useState<boolean>(false);

  function handleSelectionChange(e: Chemical) {
    const isSelected = selectedChemicals.includes(e.id);

    if (isSelected) {
      setSelectedChemicals(selectedChemicals.filter(chemical => chemical !== e.id));
      handleChange(
        "chemical",
        selectedChemicals.filter(chemical => chemical !== e.id)
      );
      return;
    }
    setSelectedChemicals([...selectedChemicals, e.id]);
    handleChange("chemical", [...selectedChemicals, e.id]);
  }

  const { loading: loadingChemicals } = useApiService<Chemical[]>({
    url: "chemical",
    apiName: "core",
    method: "GET",
    onSuccess: data => {
      const selectedChemicals = data
        .filter((item: Chemical) => formData.chemical?.includes(item.id))
        .map((item: Chemical) => item.id);
      setSelectedChemicals(selectedChemicals);
      setChemicalData(data);
    },
  });

  function handleAllSelected() {
    if (!allSelected) {
      setSelectedChemicals(chemicalData.map(item => item.id));
      handleChange(
        "chemical",
        chemicalData.map(item => item.id)
      );
      return;
    }

    setSelectedChemicals([]);
    handleChange("chemical", []);
  }

  return (
    <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
      <p className={"mt-4"}>
        What chemicals will there be on site? This can be updated and expanded once the site is
        created as well.
      </p>
      {loadingChemicals ? (
        <div
          style={{
            width: "100%",
            height: "500px",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <>
          {chemicalData.length > 0 ? (
            <>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Checkbox
                  checked={allSelected}
                  onChange={() => {
                    setAllSelected(!allSelected);
                    handleAllSelected();
                  }}
                  label={"Select all"}
                />
              </div>
              <div className={styles["responsive-grid-3"]}>
                {chemicalData.map((item: Chemical) => {
                  return (
                    <div key={item.id} className={styles["check-item"]}>
                      <Checkbox
                        checked={selectedChemicals.includes(item.id)}
                        label={item.name}
                        onChange={() => handleSelectionChange(item)}
                      />
                      <span>{item.type}</span>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div>
              <h3>No chemicals were found!</h3>
            </div>
          )}
        </>
      )}
    </div>
  );
}
